import { useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { UserService } from '../../services/user/userService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage users fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de usuarios.
----------------------------------------------------------------------------------------*/

const useUsers = (initialFilters = {}) => {

    // STATES

    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { userCan } = usePrivilege();

    const [filters, setFilters] = useState<any>({
        limit: 500,
        filter_filters: { ...initialFilters }
    });

    // FUNCTIONS

    const fetchData = async (filters?: any) => {
        if (!userCan('list', 'user')) return;
        setLoading(true);
        try {
            const response = await (new UserService()).listForSelect(filters);
            const fetchedData = response.getResponseData()?.data;
            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: any) => ({
                    value: data.id,
                    label: data.name + ' ' + (data.lastName ? `${data.lastName}` : ''),
                    teamManager: data.teamManager,
                    teamParticipant: data.teamParticipant,
                    roleId: data.roleId,
                    createdAt: data.createdAt,
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(filters);
    }, [filters]);

    const getUsersList = (entity?: string | null, notShowStatusID?: Array<string> | null, notShowStatusName?: Array<string> | null) => {
        let dataCopy = [...data];
        if (entity) return dataCopy.filter((state: any) => state.entity === entity);
        if (notShowStatusID && Array.isArray(notShowStatusID)) dataCopy = dataCopy.filter((state: any) => !notShowStatusID.includes(state.value));
        if (notShowStatusName && Array.isArray(notShowStatusName)) dataCopy = dataCopy.filter((state: any) => !notShowStatusName.includes(state.label));
        return dataCopy;
    };
    
    const updateHookFilters = (f?: any) => {
        setFilters({ ...filters, filter_filters: { ...filters.filter_filters, ...f.filter_filters } });
    };

    return {
        fetchUsers: fetchData,
        updateHookFilters,
        getUsersList,
        usersLoading: loading
    };
}

export default useUsers;